module.exports = __webpack_public_path__ + "web/img/img4.07f363e7.png";